<template>
  <div class="relative mx-auto max-w-3xl bg-white p-8">
    <img alt="" class="absolute right-0 top-0 mx-auto mb-4 mt-auto" :src="forumImageUrl" />
    <div class="relative z-10">
      <h2 class="text-brown text-left text-2xl text-gold3">Our concierge team is at your service</h2>
      <ul class="mt-6 space-y-2 text-gray4">
        <li class="flex items-start">
          <span class="mr-2">•</span>
          Transportation arrangements
        </li>
        <li class="flex items-start">
          <span class="mr-2">•</span>
          Organizing your experiences and itinerary
        </li>
        <li class="flex items-start">
          <span class="mr-2">•</span>
          Additional details about specific experiences
        </li>
      </ul>
      <div class="mx-auto mt-4 text-center md:w-96">
        <PrimaryButton @click="onClickContact">Request itinerary assistance</PrimaryButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import forumImageUrl from '@/wabunka-src/common/assets/img/forum.png';
import { PrimaryButton } from '@/wabunka-src/common/components';

const router = useRouter();

const onClickContact = () => {
  router.push(`/contact/?booking=true`);
};
</script>
